import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { Bell } from "lucide-react";

export function AppNotificationsBell({ accent = "#3a5a40" }) {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const ref = useRef(null);
  const navigate = useNavigate();

  const load = async () => {
    try { const { data } = await api.get("/notifications"); setItems(data.items || []); setUnread(data.unread || 0); } catch { /* ignore */ }
  };
  useEffect(() => { load(); const t = setInterval(load, 30000); window.addEventListener("lexarra:notifications", load); return () => { clearInterval(t); window.removeEventListener("lexarra:notifications", load); }; }, []);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h); return () => document.removeEventListener("mousedown", h);
  }, []);

  const markRead = async (it) => {
    if (it.link) { setOpen(false); navigate(it.link); }
    if (it.read) return;
    try { await api.post(`/notifications/${it.id}/read`); } catch { /* ignore */ }
    setItems((xs) => xs.map((x) => (x.id === it.id ? { ...x, read: true } : x)));
    setUnread((u) => Math.max(0, u - 1));
  };

  const clearAll = async () => {
    try { await api.post("/notifications/read-all"); } catch { /* ignore */ }
    setItems((xs) => xs.map((x) => ({ ...x, read: true }))); setUnread(0);
  };

  return (
    <div className="relative" ref={ref}>
      <button onClick={() => setOpen((o) => !o)} data-testid="app-notif-bell" className="relative w-9 h-9 rounded-lg flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-white/5 transition-colors">
        <Bell size={17} />
        {unread > 0 && <span data-testid="app-notif-unread" className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full text-white text-[10px] font-bold flex items-center justify-center" style={{ background: accent }}>{unread}</span>}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-80 max-h-96 overflow-y-auto rounded-xl border border-white/10 bg-[#0b0f18] shadow-2xl z-50 p-2" data-testid="app-notif-panel">
          {items.length > 0 && (
            <div className="flex items-center justify-between px-2 pt-1 pb-2">
              <span className="text-[11px] uppercase tracking-wider text-muted-foreground">Notifications</span>
              <button onClick={clearAll} data-testid="app-notif-clear-all" className="text-[11.5px] font-medium hover:opacity-80" style={{ color: accent }}>Clear All</button>
            </div>
          )}
          {items.length === 0 && <p className="text-[12.5px] text-muted-foreground p-4 text-center">No notifications yet.</p>}
          {items.map((it) => (
            <button key={it.id} onClick={() => markRead(it)} data-testid={`app-notif-${it.type}`} className={`w-full text-left p-3 rounded-lg hover:bg-white/5 transition-colors ${!it.read ? "bg-white/[0.03]" : ""}`}>
              <div className="flex items-center gap-1.5">
                {!it.read && <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{ background: accent }} />}
                <div className="text-[12.5px] font-medium text-foreground">{it.title}</div>
              </div>
              <div className="text-[11.5px] text-muted-foreground leading-snug mt-0.5">{it.body}</div>
              <div className="text-[10px] text-muted-foreground/60 mt-1">{new Date(it.created_at).toLocaleString()}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
